// extracted by mini-css-extract-plugin
module.exports = {"card":"Forecast_card__n_nZv","box":"Forecast_box__1v5YN"};